import { styled } from "styled-components";
import { CircleBgProps } from "./types";


const CircleBg = styled.div<CircleBgProps>`
  width: ${({ $circleBgSize, $circleBgWidth }) => $circleBgSize || $circleBgWidth || '280px'};
  height: ${({ $circleBgSize, $circleBgHeight }) => $circleBgSize || $circleBgHeight || '280px'};
  background-color: ${({ $circleBgColor, theme }) => (typeof $circleBgColor === 'function' ? $circleBgColor(theme) : $circleBgColor) || theme.containerbg};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  margin: ${({$circleBgMargin})=> $circleBgMargin || 0};
  align-items: center;
  overflow: hidden;
  z-index: 2;
`;

export default CircleBg;